export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_fragment_5.45be76a1.jpg";